import { render, staticRenderFns } from "./botHeathlyDrawer.vue?vue&type=template&id=2a28858a&scoped=true"
import script from "./botHeathlyDrawer.vue?vue&type=script&lang=js"
export * from "./botHeathlyDrawer.vue?vue&type=script&lang=js"
import style0 from "./botHeathlyDrawer.vue?vue&type=style&index=0&id=2a28858a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a28858a",
  null
  
)

export default component.exports